export default () => {
    const bibliographySections = document.querySelectorAll('.blockBibliography');

    if (bibliographySections.length === 0) return;

    bibliographySections.forEach(section => {
        const moreButton = section.querySelector('.blockBibliography__more');
        const bibliographyList = section.querySelector('.blockBibliography__list');
        const moreText = moreButton.querySelector('span');
        const moreIcon = moreButton.querySelector('div');

        if (moreButton && bibliographyList && moreText) {
            moreButton.addEventListener('click', () => {
                bibliographyList.classList.toggle('show');
                moreIcon.classList.toggle('hide');

                if (bibliographyList.classList.contains('show')) {
                    moreText.textContent = 'collapse footnotes';
                } else {
                    moreText.textContent = 'expand footnotes';
                }
            });
        }
    });
}
